import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import WhatsAppTemplateSettingTable from "./WhatsAppTemplateSetting/whatsapp_template_setting_table";
import { BsCalendar2XFill } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import StepRoutes from "../../Routes/steps_routes";
import { IoLogoWhatsapp } from "react-icons/io";

const WhatsappTemplateSetting = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); 
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/whatsAppTemplateSetting/getAll", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.whatsAppTemplateSettingData);
          setTotalPages(Math.ceil(res.data?.whatsAppTemplateSettingCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center mb-3">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <IoLogoWhatsapp style={{ color: "green" }} />
                  What's App Template Setting
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/create-whatsapp-template-setting"}>
                    <button className="btn btn-primary d-none d-sm-block">
                      <BsCalendar2XFill className="me-2 fs-2" /> ADD NEW
                      WHATSAPP TEMPLATE
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-sm-12 py-2">
              <div className="card">
                <WhatsAppTemplateSettingTable
                  data={data}
                  currentPage={page}
                  itemsPerPage={50}
                />

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default WhatsappTemplateSetting;
